<template>
  <div class="soluction">
   
    <div class="banner_pc" @click="getHouse">
      <img src="https://www.bjecpower.com/img/gw/pb01.png" alt="">
    </div>
    <div class="banner_mo">
      <img src="https://www.bjecpower.com/img/gw/mb01.png" alt="">
    </div>
    <div class="banner_mo"></div>
    <!-- 行业痛点 -->
    <div class="solu_header">
      <div class="home_con">
        <div class="title_flex">
          <p class="solu_title">行业痛点</p>
          <p class="solu_title_er first">
            能源成本极难以控制，扩建规模太过困难
          </p>
        </div>
        <div class="header_leftzong">
          <div class="header_left">
            <!-- 背景图 -->
            <div class="bg_title aa">
              <img class="bg_none" src="@/assets/mobile/4.png" alt="" />
              <span class="span_mo">车位信息不透明</span>
            </div>
            <p>
              设备状态信息不透明且用户无法实时查看充电场站车位情况，在用户里程焦虑的前提下雪上加霜。用户寻找"空闲"设备消耗巨大精力，行驶到电站还会出现“空跑”的情况。导致"设备状态"失去应有的意义。
            </p>
          </div>
          <div class="header_left left_aa">
            <!-- 背景图 -->
            <div class="bg_title bb">
              <img class="bg_none" src="@/assets/mobile/5.png" alt="" />
              <span>场站运营效率低</span>
            </div>
            <p>
              新能源车充满滞留、燃油车站位，已成为电站运营效率低的命题。不仅对用户体验极差，导致运营品牌的口碑造成极大的影响。在运维工作合格的前提下，充电设备无一可用的尴尬境遇。
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 方案展示 -->
    <div class="zhanshi_pc">
      <div class="home_con">
        <div class="title_flex">
          <p class="solu_title">方案展示</p>
          <p class="solu_title_er">车位状态及时获取,停车便可即插即充</p>
        </div>
        <div class="hh_title chuneng" >
          <img src="@/assets/solu/hh.png" alt="" />
          <p>场站智能运营系统</p>
        </div>

        <img
          style="width: 100%; height: 392px"
          src="@/assets/solu/22.png"
          alt=""
        />

        

        <div class="hh_title" style="padding-top:72px;">
          <img src="@/assets/solu/hh.png" alt="" />
          <p>动力云AIOps平台</p>
        </div>

        <ul class="newenergy">
          <li>
            <img src="@/assets/solu/13.png" alt="" />
            <div>
              <p class="li_aa">平台支持</p>
              <br />
              <p class="li_bb">
                车位级精细化运营：针对车位事件包括进出、类别、停车、充电等情况进展统计分析。<br /><br />

                工单自动化派发：占位驱离事件自动派发工单，系统智能化识别工单分配处理效率，实现实时性。<br /><br />

                车位级实时情况监控：针对车位实时状态把控，为用户侧提供依据，误差值可降低至1s。
              </p>
            </div>
          </li>
          <li>
            <img src="@/assets/solu/14.png" alt="" />
            <div>
              <p class="li_aa">终端支持</p>
              <br />
              <p class="li_bb">
                热成像设备：对充电桩的温度进行实时监测，避免因高温引起的损害。<br /><br />

                监控摄像头：对车位的状态变化进行实时更新，保证车位的正常化展示。<br /><br />

                终端设备配合云平台进行车牌信息、报警信息等信息的采集，识别存储及上传至云AI平台。<br /><br />
              </p>
            </div>
          </li>
          <li>
            <img src="@/assets/solu/15.png" alt="" />
            <div>
              <p class="li_aa">运营周报</p>
              <br />
              <p class="li_bb">
                周期性生成车位运营周报邮件自动发送。<br /><br />
                精准化识别用户车辆信息以及车位使用情况进行自动统计。<br /><br />
                成本周期性回收运营数据，为精细化运营提供依据。<br /><br />
              </p>
            </div>
          </li>
          <li>
            <img src="@/assets/solu/16.png" alt="" />
            <div>
              <p class="li_aa">即插即充</p>
              <br />
              <p class="li_bb">
                无充电桩改造成本，无车型限制。<br /><br />

                操作简便只需手机端绑定车牌号即可。<br /><br />

                依托AI摄像头+充电运营平台,实现全面即插即充功能。
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 移动端方案展示 -->
    <div class="zhanshi_mo">
      <div class="home_con">
        <div class="title_flex">
          <p class="solu_title">方案展示</p>
          <p class="solu_title_er">车位状态及时获取,停车便可即插即充</p>
        </div>
        <div class="hh_title">
          <img src="@/assets/mobile/hh.png" alt="" />
          <p>场站智能运营系统</p>
        </div>
        <div class="mo_show">
            <span>智能运维平台基于充电站视频的数字化应用方案设计以视频感知为基础，对充电站站内多场景的人、车、位、货、场、行为等多维度数据进行智能识别分析，实现充电站场景物联，通过物联平台和AI数据分析系统，实现针对充电站业务的智慧应用。</span>
            <div>
                <img src="@/assets/mobile/dui.png" alt="" />
                <p>智慧应用</p>
            </div>
            <img class="show_aa" src="@/assets/mobile/aa.png" alt="" />
            <div>
                <img src="@/assets/mobile/dui.png" alt="" />
                <p>云服务管理平台</p>
            </div>
            <img class="show_aa" src="@/assets/mobile/bb.png" alt="" />

             <div>
                <img src="@/assets/mobile/dui.png" alt="" />
                <p>动力云 AIOps</p>
            </div>
            <img class="show_aa" src="@/assets/mobile/cc.png" alt="" />

             <div>
                <img src="@/assets/mobile/dui.png" alt="" />
                <p>硬件</p>
            </div>
            <img class="show_aa" src="@/assets/mobile/dd.png" alt="" />

          
         
         
        </div>
       
        <div class="hh_title">
          <img src="@/assets/mobile/hh.png" alt="" />
          <p>动力云AIOps平台</p>
        </div>

        <ul class="newenergy_mo">
          <li>
            <div>
              <img src="@/assets/mobile/a1.png" alt="" />
              <span>平台支持</span>
            </div>
            <p>
              车位级精细化运营：针对车位事件包括进出、类别、停车、充电等情况进展统计分析。<br /><br />

              工单自动化派发：占位驱离事件自动派发工单，系统智能化识别工单分配处理效率，实现实时性。<br /><br />

              车位级实时情况监控：针对车位实时状态把控，为用户侧提供依据，误差值可降低至1s。<br/>
            </p>
          </li>
          <li>
            <div>
              <img src="@/assets/mobile/a2.png" alt="" />
              <span>终端支持</span>
              </div>
              <p>热成像设备：对充电桩的温度进行实时监测，避免因高温引起的损害。<br /><br />

              监控摄像头：对车位的状态变化进行实时更新，保证车位的正常化展示。<br /><br />

              终端设备配合云平台进行车牌信息、报警信息等信息的采集，识别存储及上传至云AI平台。<br /></p>

        </li>
        <li>
          <div>
            <img src="@/assets/mobile/a3.png" alt="" />
            <span>运营周报</span>
          </div>
          <p>周期性生成车位运营周报邮件自动发送。<br />
              精准化识别用户车辆信息以及车位使用情况进行自动统计。<br />
              成本周期性回收运营数据，为精细化运营提供依据。<br /></p>
         
        </li>
        <li>
           <div>
            <img src="@/assets/mobile/a4.png" alt="" />
            <span>即插即充</span>
          </div>
          <p>无充电桩改造成本，无车型限制。<br />

              操作简便只需手机端绑定车牌号即可。<br />

              依托AI摄像头+充电运营平台,实现全面即插即充功能。</p>
         
        </li>
        </ul>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="solu_header" style="height: 532px">
      <div class="home_con">
        <div class="title_flex yingyong">
          <p class="solu_title">应用场景</p>
          <p class="solu_title_er">AI智能管理车位，实现精细化智能运营。</p>
        </div>

        <!-- 背景图片 -->
        <ul class="appli">
          <li @mouseover="appliMouseover(0)" ref="keyframes_o">
            <div class="app_hover">
              <img src="@/assets/solu/29.png" alt="" />
              <p class="appnor_tit">自建场站</p>
              <p class="appnor_line"></p>
              <p class="appnor_con">自营场站已实现全面精细化运营，既插既充。</p>
            </div>
            <div class="app_nor">
              <img src="@/assets/solu/29.png" alt="" />
              <p class="appnor_tit">自建场站</p>
            </div>
          </li>
          <li
            style="margin-left: 48px"
            @mouseover="appliMouseover(1)"
            ref="keyframes_t"
          >
            <div class="app_hover">
              <img src="@/assets/solu/29.png" alt="" />
              <p class="appnor_tit">合作场站</p>
              <p class="appnor_line"></p>
              <p class="appnor_con">
                目前已对接10家场站，实现精细化运营，通过AI进行无人值守式智慧监控。
              </p>
            </div>
            <div class="app_nor">
              <img src="@/assets/solu/30.png" alt="" />
              <p class="appnor_tit">合作场站</p>
            </div>
          </li>
        </ul>

        <!-- 移动背景图片 -->
        <ul class="appli_mo">
          <li>
            <div>
              <img src="@/assets/solu/29.png" alt="" />
              <span>自建场站</span>
            </div>
            <p>自营场站已实现全面精细化运营,既插既充。</p>
          </li>
          <li>
            <div>
              <img src="@/assets/solu/30.png" alt="" />
              <span>合作场站</span>
            </div>
            <p style="margin-top:31px;">目前已对接10家场站,实现精细化运营,通过AI进行无人值守式智慧监控。</p>
          </li>
        </ul>
      </div>
    </div>

   
    <!-- 回到顶部 -->
    <div class="home_pos" v-if="top">
      <div class="father">
          <ul class="son">
            <li>
              <img src="@/assets/solu/111.png" alt="" />
              <div>
                <p>咨询人</p>
                <p>刘经理</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/222.png" alt="" />
              <div>
                <p>岗位</p>
                <p>市场经理</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/333.png" alt="" />
              <div>
                <p>电话</p>
                <p>17710505631</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/44.png" alt="" />
              <div>
                <p>邮箱</p>
                <p>hrzl@ec-power.cn</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/55.png" alt="" />
              <div>
                <p>微信</p>
                <p>hezlf_ecpower</p>
              </div>
            </li>
          </ul>
      </div>

      <div class="father_we">
        <div class="son_we">
          <img src="@/assets/pc/er.png" alt="" />
        </div>
        
      </div>

      <div @mouseover="gohover" v-if="!goFlag">
        <img src="@/assets/pc/goa.png" class="goimg" alt="" />
      </div>
      <div @click="backtop" @mouseout="goOut" v-else>
        <img src="@/assets/pc/gob.png" class="goimg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flagImg: true,
      flagImgs: false,
      goFlag: false,
      top: false,
      keyframesIndex: 0,
    };
  },
  mounted() {
    var THIS = this;
    window.addEventListener("scroll", function () {
      //监听滚动
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 500) {
        //如果当前滚动位置大于您的所需要达到的高度则显示置顶元素，反之不显示
        THIS.top = true;
      } else {
        THIS.top = false;
      }
    });

    let _this = this;
    let mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal", // 垂直切换选项
      loop: true, // 循环模式选项
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        // disableOnInteraction: false,
      },
      autoplay: true,
      delay: 5000,
      autoplayDisableOnInteraction: false,
      pagination: {
        el: ".swiper-pagination",
      },
    });
  },
  methods: {
    getHouse() {
      this.$bus.$emit("click");
    },
    gohover() {
      this.goFlag = true;
    },
    goOut() {
      this.goFlag = false;
    },
    gohover() {
      this.goFlag = true;
    },
    appliMouseover(e) {
      if (e === this.keyframesIndex) {
        return;
      }
      let keyframes_o = this.$refs.keyframes_o;
      let keyframes_t = this.$refs.keyframes_t;
      switch (e) {
        case 0:
          if (e === this.keyframesIndex) {
          } else {
            let keyframes_o_style = keyframes_o.children[0].style;
            let keyframes_t_style = keyframes_t.children;

            keyframes_t_style[0].style.display = "none";
            keyframes_t_style[1].style.display = "block";
            keyframes_o_style.display = "block";
            keyframes_o_style.bottom = "0px";
            keyframes_t_style[1].style.bottom = "48px";
            keyframes_o.children[1].style.display = "none";
            setTimeout(() => {
              keyframes_t_style[1].style.bottom = "24px";
              keyframes_o_style.bottom = "24px";
            });
          }
          break;
        case 1:
          if (e === this.keyframesIndex) {
          } else {
            let keyframes_t_style = keyframes_t.children[0].style;
            let keyframes_o_style = keyframes_o.children;

            keyframes_o_style[0].style.display = "none";
            keyframes_o_style[1].style.display = "block";
            keyframes_t_style.display = "block";
            keyframes_t_style.bottom = "0px";
            keyframes_o_style[1].style.bottom = "48px";
            setTimeout(() => {
              keyframes_t_style.bottom = "24px";
              keyframes_o_style[1].style.bottom = "24px";
            });
            keyframes_t.children[1].style.display = "none";
          }
          break;
      }
      this.keyframesIndex = e;
    },

    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>


<style scoped>
  .solu_title_er {
   font-size: 14px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #9ea5bb;
line-height: 63px;
margin-left: 16px;
  }
.banner_pc{
  width:100%;
  box-sizing: border-box;
}
.banner_pc img{
  max-width:100%;
  width:100%;
}
.bg_none,
.zhanshi_mo,
.appli_mo,
.banner_mo {
  display: none;
}
.header_left span:nth-child(2) {
  display: block;
  padding-top: 0px;
}


.son_we {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 0;
  right: 85%;
  /* 收回的时候快一点 */
  transition: width 200ms;
}

/* 交集选择器，所以父子关系的div盒子才可以 */
.father_we:hover .son_we {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 190px;
  height: 214px;
  transition: width 800ms;
}
.home_pos {
  position: fixed;
  right: 16px;
  bottom: 6%;
  width: 100px;
}

.home_pos .goimg {
  width: 115px;
  height: 115px;
  cursor: pointer;
}

.father {
  width: 99px;
  height: 112px;
  background-image: url("https://www.bjecpower.com/img/gw/zx.png");
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.son {
  height: 0px;
  width: 0px;
  /* max-width: 0px; */
  position: absolute;
  top: 0;
  right: 95%;
  /* 收回的时候快一点 */
  transition: width 200ms;
  overflow: hidden;
}
.father:hover .son {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 233px;
  /* max-width: 233px; */
  height: 318px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(0, 52, 144, 0.12);
  transition: width 800ms;
  /* animation: son 0.5s linear; */
}
.father_we {
  width: 99px;
  height: 112px;
  background-image: url("https://www.bjecpower.com/img/gw/wx.png");
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.son_we {
  height: 214px;
  width: 190px;
  /* max-width: 0px; */
  position: absolute;
  top: 0;
  right: 95%;
  /* 收回的时候快一点 */
  /* transition: width 200ms; */
  overflow: hidden;
}
.son_we img{
  height: 214; 
  width: 190px;
  position: absolute;
  top: 0;
  right: -100%;
}
.son li {
  display: flex;
}
.son li img {
  width: 20px;
  height: 20px;
  margin: 24px 0px 0px 32px;
}
.son li div {
  margin-left: 12px;
  margin-top: 18px;
  text-align: left;
}
.son li div p:nth-child(1) {
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5a6073;
  line-height: 21px;
}
.son li div p:nth-child(2) {
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 18px;
  margin-top: 3px;
}
/* 交集选择器，所以父子关系的div盒子才可以 */
.father_we:hover .son_we img {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 190px;
  height: 214px;
  transition: 800ms;
  right:0;
}
.son ul li {
  display: flex;
}
.soluction {
  width: 100%;
  background: #fff;
}
.newenergy {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  text-align: left;
  padding-bottom: 56px;
}
.bg_title {
  width: 100%;
  height: 86px;

  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.aa {
  background-image: url("https://www.bjecpower.com/img/gw/20.png");
}
.bb {
  background-image: url("https://www.bjecpower.com/img/gw/21.png");
}
.bg_title span {
  display: block;
  font-size: 22px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 86px;
  text-align: left;
  padding-left: 24px;
}
.newenergy li {
  width:50%;
  display: flex;
}
.newenergy li:nth-child(2),.newenergy li:nth-child(4){
  justify-content: end;
}
.newenergy li:nth-child(3) {
  margin-top: 41px;
}
.newenergy li img {
  width: 70px;
  height: 75px;
}
.newenergy div {
  margin-left: 32px;
  width: 340px;
}
.newenergy .li_aa {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 30px;
}
.newenergy .li_bb {
  width: 340px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 21px;
}
.appli {
  display: flex;
  text-align: left;
  position: relative;
}
.appli li img {
  width: 43px;
  height: 40px;
}
.appli li {
  width: 47.6%;
  height: 310px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  position: relative;
  cursor: pointer;
  bottom: 0;
  transition: 1s;
}
/* .appli li:hover .app_hover {
  animation: bottom 0.5s linear;
  bottom: 24px;
  display: block;
} */
.appli li:hover .app_nor {
  display: none;
}
/* .appli li:hover::before {
  transition: 3s;
} */
@keyframes bottom {
  0% {
    bottom: 0;
  }
  100% {
    bottom: 24px;
  }
}
.appli li:nth-child(1) {
  background-image: url("https://www.bjecpower.com/img/gw/pb05.png");
}
.appli li:nth-child(2) {
  background-image: url("https://www.bjecpower.com/img/gw/pb04.png");
}

.app_hover {
  position: absolute;
  width:90%;
  left: 24px;
  bottom: 24px;
  display: none;
  transition: 1s;
}
.appli li:first-child .app_hover {
  display: block;
}
@keyframes callback {
  0% {
    bottom: 48px;
  }
  100% {
    bottom: 24px;
  }
}
.appnor_line {
  border: 1px solid #ffffff;
  margin: 24px 0px 15px 0px;
  opacity: 0.6;
}
.appnor_con {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  line-height: 27px;
}
.app_nor {
  /* animation: callback 0.5s linear; */
  position: absolute;
  left: 24px;
  bottom: 48px;
  transition: 1s;
}
.appli li:first-child .app_nor {
  display: none;
}
.appnor_tit {
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 39px;
}
</style>

<style scoped>

@media screen and (max-width: 768px) {
  .yingyong{
    padding:50px 0px 40px 0px!important;
  }
  .solu_title_er {
    font-size: 12px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #9ea5bb;
    line-height: 11px;
    margin-left:0px;
  }
  
.banner_pc{
  display:none;
}
    .banner_mo{
    display:block;
  width:100%;
  box-sizing: border-box;
}

.banner_mo img{
  max-width:100%;
  width:100%;
}
  .mo_show {
    height: 553px;
    background: #F7FBFF;
    /* opacity: 0.2; */
    border: 1px solid #CFE8FF;
    margin: 32px 15px;
    box-sizing: border-box;
  }
  .mo_show span {
    display: block;
    text-align: left;
    margin: 24px 15px 0px 15px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
  }
  .mo_show div {
    display: flex;
    align-items: center;
    margin: 24px 15px 0px 15px;
  }
  .mo_show div img {
    width: 15px;
    height: 12px;
  }
  .mo_show div p {
    font-size: 15px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 15px;
    margin-left: 8px;
  }
  .show_aa {
    width: 92%;
    height: 45px;
    margin-top: 16px;
  }
  .newenergy_mo {
    margin: 0px 15px;
  }
  .newenergy_mo li div {
    display: flex;
    align-items: center;
    margin: 32px 0px 15px 0px;
  }
  .newenergy_mo li div img {
    width: 35px;
    height: 35px;
    margin-right: 12px;
  }
  .newenergy_mo li div span {
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 18px;
  }
  .newenergy_mo li p {
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
    text-align: left;
  }
  .zhanshi_pc,
  .appli {
    display: none;
  }
  .zhanshi_mo {
    display: block;
  }
  .appli_mo {
    display: block;
  }
  .appli_mo div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 31px;
  }
  .appli_mo div img {
    width: 23px;
    height: 20px;
  }
  .appli_mo div span {
    display: block;
    font-size: 20px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    margin-left:8px;
  }
  .appli_mo p {
    width: 64%;
    font-size: 13px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #ffffff;
    line-height: 19px;
    text-align: left;
    margin: 40px auto 0px auto;
  }

  .appli_mo li {
    width: 92%;
    height: 173px;
    margin: 15px 15px 0px 15px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .appli_mo li:nth-child(1) {
    background-image: url("https://www.bjecpower.com/img/gw/mb05.png");
  }
  .appli_mo li:nth-child(2) {
    background-image: url("https://www.bjecpower.com/img/gw/mb04.png");
  }

  .bg_none {
    display: block;
  }
  .header_leftzong {
    display: block;
    padding-top: 10px;
  }
  .first {
    display: none;
  }
  .header_left {
    width: 100%;
    height: 136px;
    border: none;
  }
  .bg_title {
    width: 100%;
    display: flex;
    align-items: center;
    height: 0px;
    margin: 32px 0px 17px 0px;
  }
  .bg_title img {
    display: block;
    width: 35px;
    height: 35px;
    margin-left: 12px;
  }
  .bg_title span {
    display: block;
    margin-left: -12px;
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27 !important;
    line-height: 16px;
    text-align: left;
  }
  .aa {
    background-image: none !important;
  }
  .bb {
    background-image: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/solu/solub.vue